import React from 'react';

const BufferingLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="relative w-12 h-12">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-[#E5FFE6] rounded-full"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-[#29DC5B] rounded-full border-t-transparent animate-spin"></div>
      </div>
    </div>
  );
};

export default BufferingLoader; 